import React, { Children } from 'react';
export function PrivacyPage() {
  const handleBack = () => {
    window.location.hash = '';
  };
  return <div className="min-h-screen bg-navy-950 text-slate-100" data-id="element-562">
      <div className="max-w-4xl mx-auto px-6 py-20" data-id="element-563">
        <button onClick={handleBack} className="text-mint-500 hover:text-mint-400 mb-8 inline-flex items-center gap-2 transition-colors" data-id="element-564">
          ← Back to home
        </button>

        <div className="prose prose-invert prose-slate max-w-none" data-id="element-565">
          <h1 className="text-4xl font-bold mb-2" data-id="element-566">Privacy Policy</h1>
          <p className="text-slate-400 mb-8" data-id="element-567">Last updated: February 2, 2026</p>

          <div className="space-y-8 text-slate-300 leading-relaxed" data-id="element-568">
            <p data-id="element-569">
              Pulsewave ("Pulsewave," "we," "us") respects your privacy. This
              Privacy Policy explains how we collect, use, share, and protect
              information when you visit https://pulsewaveco.com or use our
              products and services (collectively, the "Services").
            </p>

            <section data-id="element-570">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-571">
                1. Information we collect
              </h2>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-572">
                A. Information you provide
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-573">
                <li data-id="element-574">
                  Phone number, which we use as your primary account identifier
                </li>
                <li data-id="element-575">
                  Optional profile information you choose to provide (such as
                  name, email address, social handles)
                </li>
                <li data-id="element-576">
                  Content you submit, including messages, feedback, or form
                  responses
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-577">
                B. Authentication information
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-578">
                <li data-id="element-579">
                  We send one-time passcodes (OTP) to your phone number for
                  login and account verification
                </li>
                <li data-id="element-580">
                  We may store limited authentication-related metadata (such as
                  timestamps, delivery status, device or session information) to
                  help secure accounts and prevent fraud
                </li>
                <li data-id="element-581">We do not store reusable passwords</li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-582">
                C. Information collected automatically
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-583">
                <li data-id="element-584">
                  Device and usage information such as IP address, browser type,
                  pages viewed, referring URLs, timestamps, and interactions
                </li>
                <li data-id="element-585">
                  Cookies or similar technologies used for basic functionality
                  and analytics
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-586">
                D. Information from third parties
              </h3>
              <p data-id="element-587">
                We work with third-party service providers (e.g., SMS delivery,
                hosting, analytics, customer support) who process information on
                our behalf
              </p>
            </section>

            <section data-id="element-588">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-589">
                2. How we use information
              </h2>
              <p data-id="element-590">We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-591">
                <li data-id="element-592">
                  Create and manage accounts using phone-number-based login
                </li>
                <li data-id="element-593">
                  Send login passcodes and important service-related messages
                </li>
                <li data-id="element-594">Operate, maintain, and improve the Services</li>
                <li data-id="element-595">
                  Monitor usage, analyze performance, and improve user
                  experience
                </li>
                <li data-id="element-596">
                  Detect, prevent, and address fraud, abuse, or security issues
                </li>
                <li data-id="element-597">
                  Communicate with you for support and administrative purposes
                </li>
              </ul>
            </section>

            <section data-id="element-598">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-599">
                3. How we share information
              </h2>
              <p data-id="element-600">We may share information with:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-601">
                <li data-id="element-602">
                  Service providers who help us operate the Services, under
                  contractual confidentiality obligations
                </li>
                <li data-id="element-603">
                  Legal or regulatory authorities if required by law or to
                  protect rights, safety, or security
                </li>
                <li data-id="element-604">
                  Business partners or successors in connection with a merger,
                  acquisition, financing, or sale of assets
                </li>
                <li data-id="element-605">With your direction or consent</li>
              </ul>
              <p className="mt-4" data-id="element-606">
                We do not sell your personal information in the ordinary sense.
              </p>
            </section>

            <section data-id="element-607">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-608">
                4. SMS communications
              </h2>
              <p data-id="element-609">
                By providing your phone number, you consent to receive
                transactional messages, including one-time passcodes and
                account-related notifications. Message and data rates may apply.
                We do not guarantee uninterrupted or timely delivery of SMS
                messages due to carrier or network factors.
              </p>
            </section>

            <section data-id="element-610">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-611">
                5. Cookies and analytics
              </h2>
              <p data-id="element-612">
                We use cookies and similar technologies to enable core site
                functionality and understand how the Services are used. You can
                control cookies through your browser settings, though some
                features may not function properly without them.
              </p>
            </section>

            <section data-id="element-613">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-614">
                6. Data retention
              </h2>
              <p data-id="element-615">
                We retain personal information only as long as necessary to
                provide the Services, comply with legal obligations, resolve
                disputes, and enforce our agreements. We may retain aggregated
                or de-identified data for longer periods.
              </p>
            </section>

            <section data-id="element-616">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-617">
                7. Security
              </h2>
              <p data-id="element-618">
                We take reasonable administrative, technical, and physical
                measures to protect your information. However, no system is
                completely secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section data-id="element-619">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-620">
                8. Children's privacy
              </h2>
              <p data-id="element-621">
                The Services are not intended for children under the age of 13
                (or the minimum age required in your jurisdiction). We do not
                knowingly collect personal information from children.
              </p>
            </section>

            <section data-id="element-622">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-623">
                9. Your rights
              </h2>
              <p data-id="element-624">
                Depending on your location, you may have rights to access,
                correct, or delete your personal information, or to object to
                certain processing. To make a request, contact us using the
                information below.
              </p>
            </section>

            <section data-id="element-625">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-626">
                10. Changes to this policy
              </h2>
              <p data-id="element-627">
                We may update this Privacy Policy from time to time. The "Last
                updated" date will reflect the most recent changes.
              </p>
            </section>

            <section data-id="element-628">
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-629">
                11. Contact us
              </h2>
              <p data-id="element-630">
                If you have questions about this Privacy Policy or our data
                practices, contact us at:{' '}
                <a href="mailto:support@pulsewaveco.com" className="text-mint-500 hover:text-mint-400" data-id="element-631">
                  support@pulsewaveco.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>;
}